<template>
  <div class="page">
    <div class="breadcrumb">
      <router-link to="/home">上海盛目实业集团有限公司</router-link>
      <span>></span>
      <router-link to="/desc">公司简介</router-link>
    </div>
    <div class="content-h" v-html="config.companyProfile">
      <!-- <img src="@/assets/home/02.png" alt=""> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['config'])
  }
}
</script>

<style lang="scss" scoped>
$page-center: 1200px;
.page {
  width: $page-center;
  margin: auto;
  .breadcrumb {
    margin: 50px auto 50px;
  }
}
</style>
